export default {
  occasion_types: [
    {
      key: 'business_meeting',
      label: 'Business Meeting',
      image: 'purpose_meeting.jpg'
    },
    {
      key: 'cocktail_party',
      label: 'Cocktail Party',
      image: 'purpose_cocktail.jpg',
    },
    {
      key: 'wedding',
      label: 'Wedding',
      image: 'purpose_wedding.jpg'
    },
    {
      key: 'beach',
      label: 'Beach',
      image: 'purpose_beach.jpg'
    },
    {
      key: 'conference',
      label: 'Conference',
      image: 'purpose_conference.jpg'
    },
    {
      key: 'sightseeing',
      label: 'Sightseeing',
      image: 'purpose_sight.jpg'
    }
  ],
  location_types: [
    {
      key: 'hotel',
      label: 'Hotel',
      image: 'location_hotel.jpg',
    },
    {
      key: 'airbnb',
      label: 'Airbnb',
      image: 'location_air.jpg',
    },
    {
      key: 'ship',
      label: 'Ship to my home!',
      image: 'location_ship.jpg',
    }
  ]
}